import React from 'react';
import { useI18n } from '../../i18n';

const clients = [
  { name: 'Microsoft', domain: 'microsoft.com' },
  { name: 'AWS', domain: 'aws.amazon.com' },
  { name: 'Google Cloud', domain: 'cloud.google.com' },
  { name: 'Sasol', domain: 'sasol.com' },
  { name: 'Shopify', domain: 'shopify.com' },
  { name: 'Stripe', domain: 'stripe.com' },
  { name: 'HubSpot', domain: 'hubspot.com' },
  { name: 'Zoho', domain: 'zoho.com' },
  { name: 'Salesforce', domain: 'salesforce.com' },
  { name: 'Meta', domain: 'meta.com' },
  { name: 'Atlassian', domain: 'atlassian.com' },
  { name: 'MongoDB', domain: 'mongodb.com' },
  { name: 'Cloudflare', domain: 'cloudflare.com' },
  { name: 'Twilio', domain: 'twilio.com' },
];

const stripCopy = {
  en: { kicker: 'Trusted by industry leaders', title: 'Companies we build with' },
  it: { kicker: 'Scelti dai leader del settore', title: 'Aziende con cui costruiamo' },
  hi: { kicker: 'इंडस्ट्री लीडर्स का भरोसा', title: 'हमारे साथ बनाने वाली कंपनियाँ' },
};

const Row = ({ items, reverse }) => (
  <div className="relative overflow-hidden marquee-mask">
    <div
      className={`flex gap-10 min-w-max py-2 ${reverse ? 'marquee-reverse' : 'marquee'}`}
      style={{ willChange: 'transform' }}
    >
      {[...items, ...items].map((c, idx) => (
        <a
          key={`${c.domain}-${idx}`}
          href={`https://${c.domain}`}
          target="_blank"
          rel="noreferrer noopener"
          className="shrink-0 h-16 w-40 rounded-xl bg-white border border-slate-200 hover:border-orange-300 hover:shadow-md transition-all flex items-center justify-center px-4"
          title={c.name}
        >
          <img
            src={`https://logo.clearbit.com/${c.domain}?size=160`}
            alt={c.name}
            className="max-h-8 w-auto object-contain grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fb = e.currentTarget.nextSibling;
              if (fb) fb.style.display = 'block';
            }}
          />
          <div style={{ display: 'none' }} className="text-sm font-bold text-slate-700 uppercase tracking-wide">
            {c.name}
          </div>
        </a>
      ))}
    </div>
  </div>
);

const ClientLogos = () => {
  const { lang } = useI18n();
  const c = stripCopy[lang] || stripCopy.en;

  const half = Math.ceil(clients.length / 2);
  const rowA = clients.slice(0, half);
  const rowB = clients.slice(half);

  return (
    <section className="py-16 lg:py-20 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">{c.kicker}</span>
          <h3 className="mt-2 text-2xl sm:text-3xl font-extrabold text-slate-900">{c.title}</h3>
        </div>

        <div className="space-y-4">
          <Row items={rowA} />
          <Row items={rowB} reverse />
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
